import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { LoginHeaderComponent } from './login-header.component';

@NgModule({
  declarations: [LoginHeaderComponent],
  imports: [CommonModule, NzIconModule, I18nModule],
  exports: [LoginHeaderComponent],
})
export class LoginHeaderModule {}
